export default __webpack_public_path__ + "static/instagramLogo-59131058d753c25533635a736725b892.png";